<template>
  <v-container fluid>
    <PdfModal v-model="mostrarPdf" title="Nota de ingreso" :file-name="`Nota de ingreso ${this.urgencia.contrato}`"
      :fetch-document="obtenerPdf" />
    <!-- Migas de pan -->
    <v-breadcrumbs class="pa-1 ma-1" :items="breadcrumbs" />
    <!-- Tarjeta de búsqueda -->
    <v-card outlined class="m-4">
      <v-card-title class="text-h6 font-weight-medium">
        <v-icon left color="primary" class="mr-2">mdi-magnify</v-icon>
        Búsqueda de membresías
      </v-card-title>
      <v-card-subtitle class="mb-4">
        Puedes buscar mediante el número de
        <strong>membresía</strong>, o el <strong>nombre(s) y apellido</strong> del
        <strong>titular</strong>.
      </v-card-subtitle>
      <v-card-text>
        <v-form @submit.prevent="Buscar">
          <v-row dense>
            <!-- Campo de búsqueda @keyup.enter="Buscar"-->
            <v-col cols="12" sm="6" md="4" lg="4">
              <v-text-field v-model="paramMembresia" label="Escribe aquí" outlined dense clearable class="col"
                prepend-inner-icon="mdi-magnify" @input="paramMembresia = toUpperCaseGeneral(paramMembresia)" />
            </v-col>

            <v-col>
              <v-btn color="azulfuerte" @click="Buscar" :loading="loading" :disabled="loading" outlined dark>
                {{ loading ? 'Buscando...' : 'Buscar' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-row class="mt-4">
      <v-col v-for="(item, index) in membresias" :key="item.Id || index" cols="12" md="6">
        <v-card outlined class="membership-card pa-4">
          <!-- Header -->
          <div class="d-flex justify-space-between align-start mb-3">
            <div class="pr-3">
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon small color="primary" class="mr-1">mdi-account-circle</v-icon>
                {{ item.Titular }}
              </div>

              <div class="text-caption grey--text text--darken-1 mt-1">
                Membresía:
                <strong class="black--text">{{ item.Id }}</strong>
              </div>
            </div>

            <v-chip :color="item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0 ? 'green darken-2' : 'red darken-2'"
              text-color="white" small class="font-weight-medium">
              <v-icon left x-small>
                {{ item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0 ? 'mdi-check-circle' : 'mdi-alert-circle' }}
              </v-icon>
              {{ item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0 ? 'ACTIVA' : 'SUSPENDIDA' }}
            </v-chip>
          </div>

          <v-divider class="mb-3" />

          <!-- Datos principales -->
          <v-row dense class="mb-2">
            <v-col cols="12" sm="6">
              <div class="info-box">
                <v-icon small color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                <div>
                  <div class="text-caption grey--text">Plan</div>
                  <div class="text-body-2 font-weight-medium">
                    {{ item.Plan }}
                  </div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" sm="6">
              <div class="info-box">
                <v-icon small color="primary" class="mr-2">mdi-hospital-building</v-icon>
                <div>
                  <div class="text-caption grey--text">Monto urgencias</div>
                  <div class="text-body-2 font-weight-bold">
                    {{ formatCurrency(item.MontoUrgencias) }}
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Beneficiarios -->
          <div v-if="item.Beneficiarios && item.Beneficiarios.length" class="mt-4">
            <div class="d-flex align-center mb-2">
              <v-icon small color="primary" class="mr-2">mdi-account-group</v-icon>
              <span class="text-subtitle-2 font-weight-bold">
                Beneficiarios
              </span>
            </div>

            <v-list dense class="beneficiary-list">
              <v-list-item v-for="(bene, bIndex) in item.Beneficiarios" :key="bIndex" class="beneficiary-item mb-2">
                <v-list-item-avatar size="34" color="blue lighten-5">
                  <v-icon color="primary" small>mdi-account</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="text-body-2 font-weight-medium">
                    {{ bene.Nombres }} {{ bene.Apaterno }} {{ bene.Amaterno }}
                  </v-list-item-title>

                  <v-list-item-subtitle class="text-caption">
                    {{ bene.Parentesco || 'Sin parentesco registrado' }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn color="azulfuerte" :disabled="item.MontoUrgencias === 0" @click="urgenciaMembresia(item, bene)"
                    outlined small>
                    <v-icon left small>mdi-file-document-edit-outline</v-icon>
                    Nota
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>

          <v-alert v-if="item.Estatus === 'ACTIVO' && item.MontoUrgencias > 0" dense text color="green"
            class="mt-4 mb-0">
            <v-icon left color="green darken-2">mdi-card-account-details</v-icon>
            Valida la identidad del <strong>paciente</strong> con una
            <strong>identificación oficial</strong>.
          </v-alert>
        </v-card>
      </v-col>

      <!-- Sin resultados -->
      <v-col v-if="!membresias.length" cols="12"
        class="text-center d-flex flex-column align-center justify-center py-10">
        <v-icon color="grey lighten-1" size="72">mdi-account-search-outline</v-icon>

        <h3 class="mt-4 grey--text text--darken-2">
          No se encontraron membresías
        </h3>

        <p class="grey--text mb-0">
          Verifica el número de membresía o el nombre del titular.
        </p>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogUrgencia"
      max-width="720px"
      persistent
      scrollable
    >
      <v-card class="rounded-lg">

        <!-- HEADER -->
        <v-card-title class="pa-5 pb-2 d-flex align-center">
          <v-avatar color="red lighten-5" size="42" class="mr-3">
            <v-icon color="red darken-2">
              mdi-hospital-box
            </v-icon>
          </v-avatar>

          <div>
            <div class="text-h6 font-weight-bold">
              Atención médica de urgencia
            </div>
            <div class="text-caption grey--text text--darken-1">
              Generación de nota de ingreso hospitalario
            </div>
          </div>
        </v-card-title>

        <!-- INFO -->
        <v-card-text class="px-5 pt-2 pb-0">
          <v-alert
            dense
            outlined
            type="info"
            color="blue darken-1"
            class="mb-4"
          >
            Se generará la <strong>nota de ingreso correspondiente</strong>,
            la cual deberá ser firmada por el <strong>paciente</strong> o
            <strong>titular</strong>.
          </v-alert>
        </v-card-text>

        <v-divider />

        <!-- FORMULARIO -->
        <v-card-text class="pa-5">
          <atencionUrgenciaForm
            ref="urgenciaForm"
            :urgencia="urgencia"
          />
        </v-card-text>

        <v-divider />

        <!-- ACCIONES -->
        <v-card-actions class="pa-4 grey lighten-5">
          <v-spacer />

          <v-btn
            text
            color="grey darken-1"
            :disabled="loading"
            @click="dialogUrgencia = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            depressed
            :loading="loading"
            :disabled="loading"
            @click="crearUrgencia"
          >
            Generar nota de ingreso
          </v-btn>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>

import formatFecha from '@/mixins/formatFecha';
import upperCase from '@/mixins/upperCase';
import atencionUrgenciaForm from '@/components/atencionUrgenciaForm.vue';
import PdfModal from "@/components/PdfModalComponent.vue";

import { mapGetters } from 'vuex'

export default {
  mixins: [formatFecha, upperCase],
  components: {
    atencionUrgenciaForm, PdfModal
  },
  mounted() {
    this.paramMembresia = this.$route.params.mem || '';
    if (this.paramMembresia) {
      this.getMembresias()
    }
  },
  created() {
    if (!this.getNombresApaterno) {
      this.$store.dispatch('cargarNombresApaterno'); // tu acción que llena el state
    }
  },
  data() {
    return {
      loading: false,
      mostrarPdf: false,
      dialogUrgencia: false,
      idArchivoSelect: null,
      urgencia: {
        Contrato: null,
        FechaIngreso: new Date().toISOString().split('T')[0],
        Paciente: null,
        Edad: null,
        Parentesco: null,
        IdBeneficiado: null,
        Titular: null,
        Plan: null,
        Colectivo: null,
        FecVigencia: null,
        // Total: null,
        // Diagnostico: null,
        // Descripcion: null,
        // MontoMaxUrgencias: 0,
        // FechaFactura: null,
        // Factura: null,
        // Tipo: null,
        NombreHospital: this.getNombresApaterno
      },
      beneficiarioSeleccionado: [],
      paramMembresia: '',
      membresias: [],
    };
  },
  computed: {
    ...mapGetters(['getNombresApaterno']),
    breadcrumbs() {
      return [
        { text: 'Inicio', disabled: true, href: '/' },
        { text: this.$route.meta.title || this.$route.name, disabled: true }
      ];
    },
    mem() {
      return this.$route.params.mem;
    }
  },
  methods: {
    async obtenerPdf() {
      return await this.$http.get(`file/${this.idArchivoSelect}/NOTA_INGRESO/pdf`,
        {
          responseType: 'blob'
        })
    },
    async abrirPdf(idArchivo) {
      this.idArchivoSelect = idArchivo
      this.mostrarPdf = true
      this.dialogUrgencia = false
    },
    getNombreHospital() {
      return this.getNombresApaterno
    },
    formatCurrency(amount) {
      return this.$formatCurrency(amount);
    },
    urgenciaMembresia(membresia, beneficiario) {
      this.urgencia.Contrato = membresia.Id
      this.urgencia.IdBeneficiado = beneficiario.Id
      this.urgencia.Paciente = `${beneficiario.Nombres} ${beneficiario.Apaterno} ${beneficiario.Amaterno}`
      //this.urgencia.MontoMaxUrgencias = monto
      this.urgencia.Edad = beneficiario.Edad
      this.urgencia.Parentesco = beneficiario.Parentesco
      this.urgencia.NombreHospital = this.getNombreHospital()
      //this.urgencia.Total = 0
      this.urgencia.Titular = membresia.Titular
      this.urgencia.Plan = membresia.Plan
      this.urgencia.FecVigencia = membresia.FecVigenciaFormat
      this.urgencia.Colectivo = membresia.Colectivo
      this.dialogUrgencia = true
    },
    crearUrgencia() {
      this.loading = true
      this.$http.post(`hospital/urgencia`, this.urgencia)
        .then(response => {
          if (response.status === 200) {
            this.abrirPdf(response.data)
          }

        }).catch(() => {
          this.dialogUrgencia = false
          let mensajeError = 'Ups, tuvimos un error no esperado. <b>Intenta más tarde</b>.';
          this.$swal.fire({
            position: 'center',
            html: mensajeError,
            icon: 'error',
            confirmButtonText: 'Cerrar',
            showCloseButton: true,
            showConfirmButton: true,
            backdrop: false,
            customClass: {
              confirmButton: 'v-btn v-btn--contained theme--light v-size--default boton-vuetify',
              closeButton: 'v-btn boton-close'
            },
          })
        })
        .finally(() => {
          this.loading = false
        });



    },
    Buscar() {
      this.getMembresias()
    },
    getMembresias() {
      this.loading = true

      this.$http.get(`membresia/buscaMembresia?qry=${this.paramMembresia || null}`)
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.membresias = response.data
            }
          }
        })
        .catch(() => {
        }).finally(() => {
          this.loading = false
        });
    }
  },
};
</script>
<style type="scss" scoped>
.membership-card {
  border-radius: 16px;
  transition: all 0.2s ease;
}

.membership-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08) !important;
}

.info-box {
  display: flex;
  align-items: center;
  background: #f7f9fc;
  border: 1px solid #eef1f5;
  border-radius: 12px;
  padding: 10px 12px;
  min-height: 64px;
}

.beneficiary-list {
  background: transparent;
}

.beneficiary-item {
  border: 1px solid #e6eaf0;
  border-radius: 12px;
  background: #fff;
}
</style>
